/**
 * Profile cover aspect — keep in sync with:
 * - `apps/api/config/thumbs.php` users.cover.wide `1800×460`
 * - Portfolio header crop historically used `aspectRatio={3.9}`
 *
 * Live header height is `em-calc(365)` at full bleed; the stored crop
 * frame is the API cover ratio so uploads match generated thumbnails.
 */
export const PROFILE_COVER_WIDTH = 1800;
export const PROFILE_COVER_HEIGHT = 460;
export const PROFILE_COVER_ASPECT_RATIO =
  PROFILE_COVER_WIDTH / PROFILE_COVER_HEIGHT;
